import { Inject, Injectable } from '@angular/core';
import { clearAllDrafts } from '../sketch-pad/sketch-draft-store';
import { clearAllContactDrafts } from '../components/person-entity-v2/wizard/contact-draft';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { ToastrService } from 'ngx-toastr';
import { AppConfig, APP_CONFIG } from '../app-config.module';
import SecurityUtils from '../shared/Utility/securityUtils';
import { ClientEncryptionPasswordService } from './client-encryption-password.service';
import { IndexDBService } from './indexDB/index-db.service';
import { clearVoicePreferences } from '../ai/ai-record-audio/voice-to-note';


@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    public toastr: ToastrService,
    public authService: MsalService,
    public securityUtils: SecurityUtils,
    private clientEncryptionPasswordService: ClientEncryptionPasswordService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private indexDBService: IndexDBService,

  ) { }



  // ============================================================================
  // Called if user is NOT currently logged in to force them to login page.
  // ============================================================================
  async ForceLogin() {

    const redirectPromise = new Promise<void>(async (resolve) => {
      if (this.msalGuardConfig.authRequest) {
        // ------------------
        // Logged In
        // ------------------
        console.log("ForceLogin() initiated...");

        // -------------------------------------
        // Make sure Data Cache is cleared
        // -------------------------------------
        await this.ClearDataCaches();

        // this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);

        await this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);



      } else {
        console.log("ForceLogin() --> LoginRedirect");
        this.authService.loginRedirect();
      }

      resolve();
    });
  }

  // ============================================================================
  //
  // ============================================================================
  async logout() {

    // ------------------------------------
    // Browser Cache
    // ------------------------------------
    try {
      await this.ClearDataCaches();
      console.log("Cache Cleared");
    }
    catch (error) {
      console.error("ClearDataCaches Error", error);
    }
    // Turn OFF Offline Features for next login
    await this.securityUtils.turnOffOfflineCapabilties();

    // ------------------------------------
    // Clear Password for Encryption
    // ------------------------------------
    try {
      await this.clientEncryptionPasswordService.clearUserKEK();
      this.clientEncryptionPasswordService.clearCustomKEK();
      localStorage.removeItem('userCached');
      clearAllDrafts(localStorage);
      clearAllContactDrafts(localStorage);
      console.log("Client-Side Encryption Password Cleared");
    }
    catch (error) {
      console.error("clearPassword Error", error);
    }

    // --------------------------------------------
    // Clear IndexDBs and Then Delete
    // --------------------------------------------
    try {
      const result = await this.indexDBService.DeleteAllDatabases()
        .then((result) => {
          console.log("IndexDB's Deleted");

          // ------------------------------------
          // Logout and Redirect
          // ------------------------------------
          this.authService.logoutRedirect({
            postLogoutRedirectUri: this.config.postLogoutRedirectUri
          });

        });
    }
    catch (error) {
      console.error("Delete IndexDB's Error", error);
    }



  }


  // ================================================================
  //
  // ================================================================
  async ClearBrowserAndIndexDbCaches() {

    this.indexDBService.DeleteAllDatabases();
    await this.ClearDataCaches();
  }

  async ClearKEK() {
    // ------------------------------------
    // Clear Password for Encryption
    // ------------------------------------
    try {
      await this.clientEncryptionPasswordService.clearUserKEK();
      this.clientEncryptionPasswordService.clearCustomKEK();
      console.log("Client-Side Encryption Password Cleared");
    }
    catch (error) {
      console.error("clearPassword Error", error);
    }

  }


  // ================================================================
  //
  // ================================================================
  private async ClearDataCaches(showMessage: boolean = false) {
    // -----------------------------------------
    // Clear Caches related to API Data
    // -----------------------------------------
    console.log("Clearing Data Caches");
    try {
      if (typeof caches !== 'undefined' && caches.keys) {
        const names = await caches.keys();
        await Promise.all(
          names
            .filter((name) => typeof name === 'string' && name.startsWith('ngsw:'))
            .map((name) => caches.delete(name))
        );
      }
    } catch (error) {
      console.error("ClearDataCaches ngsw delete error", error);
    }

    try {
      localStorage.removeItem('userCached');
      clearVoicePreferences(localStorage);
    } catch (error) {
      console.error("ClearDataCaches userCached error", error);
    }

    if (showMessage) {
      this.toastr.success("Cache Data Cleared");
    }

  }



}
